import { Component, HostListener, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { menu } from 'src/app/configs/menu';
import { OLD_SITE_VIDEO, OLD_SITE_HOME } from 'src/environments/environment.local';
import { LanguageService } from 'src/app/services';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { IconComponent } from '@kinomap-dev/ng-ui-lib';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: true,
  imports: [TranslateModule, RouterLink, IconComponent],
})
export class FooterComponent implements OnInit {
  windowSize: number;
  allAvailableLanguages: any;
  currentLanguage: any;
  menu = menu;
  oldVideoLink: string = OLD_SITE_VIDEO;
  oldLink: string = OLD_SITE_HOME;
  getStartedLink: string;
  rewardLink: string;

  @HostListener('window:resize', ['$event'])
  onResize(event: UIEvent) {
    const target: Window = event.target as Window;
    this.windowSize = target.innerWidth;
  }

  constructor(
    private languageService: LanguageService,
    public translate: TranslateService
  ) {
    this.allAvailableLanguages = translate.getLangs();
    this.currentLanguage = languageService.get()
      ? languageService.get()
      : translate.defaultLang;
  }

  ngOnInit(): void {
    this.languageService.langEmitter.subscribe((el: string) =>
      this.setLink(el)
    );
    this.setLink(this.languageService.get());
    this.windowSize = window.innerWidth;
  }

  get supportSafeLink(): string {
    let lang: string = this.languageService.get();
    if (lang === 'fr-FR') lang = 'fr';
    if (lang === 'de-DE') lang = 'de';
    if (!['de', 'fr', 'en-us'].includes(lang)) lang = 'en-us';
    return `https://support.kinomap.com/hc/${lang}`;
  }

  // To remove
  private setLink(el: string) {
    switch (el) {
      case 'fr-FR':
      case 'fr':
        this.getStartedLink = 'https://partner.kinomap.com/demarrer-kinomap';
        this.rewardLink = 'https://info.kinomap.com/fr-reward-program';
        break;
      case 'de-DE':
      case 'de':
        this.getStartedLink = 'https://partner.kinomap.com/starten';
        this.rewardLink = 'https://info.kinomap.com/de-reward-program';
        break;
      case 'es-ES':
      case 'es':
        this.getStartedLink = 'https://partner.kinomap.com/starten';
        this.rewardLink = 'https://info.kinomap.com/es-reward-program';
        break;
      case 'it-IT':
      case 'it':
        this.getStartedLink = 'https://partner.kinomap.com/starten';
        this.rewardLink = 'https://info.kinomap.com/it-reward-program';
        break;
      default:
        this.getStartedLink = 'https://partner.kinomap.com/getting-started';
        this.rewardLink = 'https://info.kinomap.com/en-reward-program';
        break;
    }
  }
}
